/** 기간 프리셋 — FR-2.1.
 *
 * KST 자연일 기준. 결과는 ISO8601 (KST 오프셋 +09:00 명시).
 */

export type Preset =
  | "today"
  | "yesterday"
  | "last7"
  | "last30"
  | "this_month"
  | "last_month"
  | "custom";

export interface DateRange {
  from: string; // ISO with +09:00
  to: string;
}

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

function toKstWallDate(d: Date): Date {
  // 시스템 타임존이 무엇이든 KST 자연일을 얻기 위해 UTC ms 에 +9h 가산 후 Date 생성
  return new Date(d.getTime() + KST_OFFSET_MS);
}

function dateAtKst(y: number, m: number, d: number, hh = 0, mi = 0): string {
  const yy = String(y).padStart(4, "0");
  const mm = String(m).padStart(2, "0");
  const dd = String(d).padStart(2, "0");
  const HH = String(hh).padStart(2, "0");
  const MM = String(mi).padStart(2, "0");
  return `${yy}-${mm}-${dd}T${HH}:${MM}:00+09:00`;
}

export function presetRange(p: Preset, custom?: DateRange): DateRange {
  if (p === "custom" && custom) return custom;
  const nowKst = toKstWallDate(new Date());
  const y = nowKst.getUTCFullYear();
  const m = nowKst.getUTCMonth() + 1;
  const d = nowKst.getUTCDate();

  switch (p) {
    case "today":
      return {
        from: dateAtKst(y, m, d, 0, 0),
        to: dateAtKst(y, m, d, 23, 59),
      };
    case "yesterday": {
      const yest = new Date(Date.UTC(y, m - 1, d - 1));
      return {
        from: dateAtKst(
          yest.getUTCFullYear(),
          yest.getUTCMonth() + 1,
          yest.getUTCDate(),
          0,
          0,
        ),
        to: dateAtKst(
          yest.getUTCFullYear(),
          yest.getUTCMonth() + 1,
          yest.getUTCDate(),
          23,
          59,
        ),
      };
    }
    case "last7": {
      const start = new Date(Date.UTC(y, m - 1, d - 6));
      return {
        from: dateAtKst(
          start.getUTCFullYear(),
          start.getUTCMonth() + 1,
          start.getUTCDate(),
          0,
          0,
        ),
        to: dateAtKst(y, m, d, 23, 59),
      };
    }
    case "last30": {
      const start = new Date(Date.UTC(y, m - 1, d - 29));
      return {
        from: dateAtKst(
          start.getUTCFullYear(),
          start.getUTCMonth() + 1,
          start.getUTCDate(),
          0,
          0,
        ),
        to: dateAtKst(y, m, d, 23, 59),
      };
    }
    case "this_month":
      return {
        from: dateAtKst(y, m, 1, 0, 0),
        to: dateAtKst(y, m, d, 23, 59),
      };
    case "last_month": {
      const lastM = m === 1 ? 12 : m - 1;
      const lastY = m === 1 ? y - 1 : y;
      const lastDay = new Date(Date.UTC(lastY, lastM, 0)).getUTCDate();
      return {
        from: dateAtKst(lastY, lastM, 1, 0, 0),
        to: dateAtKst(lastY, lastM, lastDay, 23, 59),
      };
    }
    default:
      return {
        from: dateAtKst(y, m, d, 0, 0),
        to: dateAtKst(y, m, d, 23, 59),
      };
  }
}

export const PRESET_LABELS: Record<Preset, string> = {
  today: "오늘",
  yesterday: "어제",
  last7: "최근 7일",
  last30: "최근 30일",
  this_month: "이번 달",
  last_month: "지난 달",
  custom: "사용자 지정",
};
